import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Observable } from "rxjs";
import * as moment from 'moment';


@Injectable()
export class CertxmlpagoService {
    public url;

    constructor(private _http: Http) {
        this.url = GLOBAL.url
    }

    async generarXml(idcarro, inforut, dirs, valores) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })
        var now = moment(new Date()).format('YYYYMMDD')
        var xmlcip = ""
        var xmlaup = ""
        var xmlnum = ""

        var valorcip = 0
        var valornum = 0
        var valoraup = 0
        var total = 0

        console.log(dirs)
        let promise = new Promise((res, rej) => {
            for (let i = 0; i < dirs.length; i++) {

                if (dirs[i].aup) {
                    if (i > 0 && dirs[i].aup) {
                        var valor = 0
                        valoraup = valoraup + valores.valor_aup

                        xmlaup = `<ser:DerechoVo>
                                <ser:CodigoDerecho>CAUTIL</ser:CodigoDerecho>
                                <ser:ValorDerecho>${valoraup}</ser:ValorDerecho>
                                </ser:DerechoVo>`


                    } else if (i == 0 && dirs[i].aup) {

                        valoraup = valoraup + valores.valor_aup

                        xmlaup = `<ser:DerechoVo>
                                <ser:CodigoDerecho>CAUTIL</ser:CodigoDerecho>
                                <ser:ValorDerecho>${valoraup}</ser:ValorDerecho>
                            </ser:DerechoVo>`

                    }


                }
                if (dirs[i].cip) {
                    if (i > 0 && dirs[i].cip) {

                        var valor = 0
                        valorcip = valorcip + valores.valor_cip

                        xmlcip = `<ser:DerechoVo>
                                <ser:CodigoDerecho>CINFPR</ser:CodigoDerecho>
                                <ser:ValorDerecho>${valorcip}</ser:ValorDerecho>
                            </ser:DerechoVo>`

                    } else if (i == 0 && dirs[i].cip) {

                        valorcip = valorcip + valores.valor_cip

                        xmlcip = `<ser:DerechoVo>
                                <ser:CodigoDerecho>CINFPR</ser:CodigoDerecho>
                                <ser:ValorDerecho>${valorcip}</ser:ValorDerecho>
                            </ser:DerechoVo>`

                    }
                }
                if (dirs[i].cnum) {
                    console.log("entre en num")
                    if (i > 0 && dirs[i].cnum) {
                        console.log("entre en mayor a 1 de num")

                        valornum = valornum + valores.valor_num

                        xmlnum = `<ser:DerechoVo>
                                <ser:CodigoDerecho>CERNUM</ser:CodigoDerecho>
                                <ser:ValorDerecho>${valornum}</ser:ValorDerecho>
                            </ser:DerechoVo>`

                    } else if (i == 0 && dirs[i].cnum) {
                        console.log("entre en 0 de num")

                        valornum = valornum + valores.valor_num

                        xmlnum = `<ser:DerechoVo>
                                <ser:CodigoDerecho>CERNUM</ser:CodigoDerecho>
                                <ser:ValorDerecho>${valornum}</ser:ValorDerecho>
                            </ser:DerechoVo>`

                    }
                }
            }

            total = valornum + valoraup + valorcip 
            var xmls = {
                data: {
                    valortotal: total,
                    xmlcip: xmlcip,
                    xmlaup: xmlaup,
                    xmlnum: xmlnum,
                }
            }

            res(xmls)
        })



        var xml = await promise
        console.log(promise)

        return xml
    }
}